// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-pro__content {
    padding: 45px 236px 166px 236px;
    background: var(--white-color);
}

.baloa-pro__change-conditions-widget {
    background: var(--white-color);
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    padding: 12px;
    margin-bottom: 24px;
}

.baloa-pro__change-conditions-widget__container {
    background: var(--new-informative-banner-bg-color);
    border-radius: 4px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.baloa-pro__change-conditions-widget__container .baloa-normal-medium {
    color: var(--primary-very-dark-color);
}

.baloa-pro__change-conditions-widget__container .baloa-names{
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
    margin-top: 8px;
}

.baloa-pro__change-conditions-widget__container .button {
    padding: 12px 24px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .baloa-pro__content {
        padding: 10px 12px;
    }

    .baloa-pro__change-conditions-widget {
        position: fixed;
        bottom: 0;
        right: 0;
        border: none;
        margin-bottom: 0;
        border-top: 1px solid var(--new-gray-background-color);
        border-radius: 0;
    }

    .baloa-pro__change-conditions-widget__container {
        flex-direction: column;
        padding: 8px;
    }

    .baloa-pro__change-conditions-widget__container .button {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-pro/views/BaloaProView.styles.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,kDAAkD;IAClD,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,SAAS;QACT,QAAQ;QACR,YAAY;QACZ,gBAAgB;QAChB,sDAAsD;QACtD,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".baloa-pro__content {\n    padding: 45px 236px 166px 236px;\n    background: var(--white-color);\n}\n\n.baloa-pro__change-conditions-widget {\n    background: var(--white-color);\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    padding: 12px;\n    margin-bottom: 24px;\n}\n\n.baloa-pro__change-conditions-widget__container {\n    background: var(--new-informative-banner-bg-color);\n    border-radius: 4px;\n    padding: 12px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.baloa-pro__change-conditions-widget__container .baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n}\n\n.baloa-pro__change-conditions-widget__container .baloa-names{\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n    margin-top: 8px;\n}\n\n.baloa-pro__change-conditions-widget__container .button {\n    padding: 12px 24px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .baloa-pro__content {\n        padding: 10px 12px;\n    }\n\n    .baloa-pro__change-conditions-widget {\n        position: fixed;\n        bottom: 0;\n        right: 0;\n        border: none;\n        margin-bottom: 0;\n        border-top: 1px solid var(--new-gray-background-color);\n        border-radius: 0;\n    }\n\n    .baloa-pro__change-conditions-widget__container {\n        flex-direction: column;\n        padding: 8px;\n    }\n\n    .baloa-pro__change-conditions-widget__container .button {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
